import { PushNotifications } from '@capacitor/push-notifications';
import api from './api'; // Assuming you have your axios/api setup here

export const setupPushNotifications = async (userId) => {
    try {
        // 1. Request permission from the user (Shows the native Android popup)
        let permStatus = await PushNotifications.checkPermissions();
        
        if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
            console.warn('User denied push notification permission');
            return;
        }

        // 2. Register the device with Google/Firebase
        await PushNotifications.register();

        // 3. Listen for the unique FCM Token
        PushNotifications.addListener('registration', async (token) => {
            console.log('✅ Push registration success, Token:', token.value);

            await api.post('/users/save-fcm-token', {
                user_id: userId,
                fcm_token: token.value
            });
        });

        // 4. Listen for errors
        PushNotifications.addListener('registrationError', (error) => {
            console.error('❌ Error on registration:', JSON.stringify(error));
        });

        // 5. Listen for a notification arriving while the app is OPEN
        PushNotifications.addListener('pushNotificationReceived', (notification) => {
            console.log('📬 Notification received:', notification);
            // You can show a custom in-app banner or alert here
        });

        // 6. Listen for the user TAPPING on the notification
        PushNotifications.addListener(
    'pushNotificationActionPerformed',
    (notification) => {
        console.log(
            '👆 Notification action performed',
            notification
        );

        const role = localStorage.getItem("role");

        if (role === "restaurant_owner") {
            window.location.href = "/restaurant-dashboard";
        } else if (role === "delivery_partner") {
            window.location.href = "/delivery-dashboard";
        } else if (role === "customer") {
            window.location.href = "/my-orders";
        } else {
            window.location.href = "/";
        }
    }
);

    } catch (error) {
        console.error("Error setting up push notifications:", error);
    }
};